module.exports = __webpack_public_path__ + "static/img/fish47.d52a74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish47.png
// module id = 2B3A
// module chunks = 0